
import React, { useEffect, useState } from "react";

import {
  Alert,
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import PaymentIcon from "@mui/icons-material/Payment";
import EripPayment from "components/EripPayment";

const getHashParams = () => {
  const hash = window.location.hash.replace(/^#/, "");

  const params = new URLSearchParams(
    hash.replace(/^adv&?/, "service=adv&")
  );

  return {
    service:
      hash === "adv" || hash.startsWith("adv&")
        ? "adv"
        : "subscription",

    summ: params.get("summ") || "",
  };
};

export default function PayPage() {
  const [service, setService] = useState(
    () => getHashParams().service
  );

  const [summ, setSumm] = useState(
    () => getHashParams().summ
  );

  const changeService = (value) => {
    setService(value);

    const parts = [];

    if (value === "adv") {
      parts.push("adv");
    }

    if (summ) {
      parts.push(`summ=${encodeURIComponent(summ)}`);
    }

    const hash =
      parts.length > 0
        ? `#${parts.join("&")}`
        : "";

    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${window.location.search}${hash}`
    );
  };

  useEffect(() => {
    const handleHashChange = () => {
      const params = getHashParams();

      setService(params.service);
      setSumm(params.summ);
    };

    window.addEventListener(
      "hashchange",
      handleHashChange
    );

    return () => {
      window.removeEventListener(
        "hashchange",
        handleHashChange
      );
    };
  }, []);

  return (
    <Container
      maxWidth="md"
      sx={{
        py: {
          xs: 3,
          sm: 5,
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: {
            xs: 2,
            sm: 3,
          },
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        {/* Заголовок страницы */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 2.5,
          }}
        >
          <PaymentIcon color="primary" />

          <Typography
            variant="h4"
            sx={{
              fontSize: {
                xs: "1.6rem",
                sm: "2rem",
              },
            }}
          >
            Как оплатить
          </Typography>
        </Box>

        {/* Способы оплаты */}
        <Typography
          variant="h6"
          sx={{ mb: 1 }}
        >
          Способы оплаты
        </Typography>

        <List
          sx={{
            pl: {
              xs: 1,
              sm: 3,
            },
            mb: 3,
          }}
        >
          <ListItem
            sx={{
              display: "list-item",
              listStyleType: "disc",
              py: 0.25,
              color: "success.main",
            }}
          >
            <ListItemText
              primary="в инфокиосках банков (без комиссии)"
            />
          </ListItem>

          <ListItem
            sx={{
              display: "list-item",
              listStyleType: "disc",
              py: 0.25,
              color: "success.main",
            }}
          >
            <ListItemText
              primary="через интернет-банкинг (ЕРИП) (без комиссии)"
            />
          </ListItem>

          <ListItem
            sx={{
              display: "list-item",
              listStyleType: "disc",
              py: 0.25,
            }}
          >
            <ListItemText
              primary={
                <>
                  в банках города{" "}
                  <Box
                    component="span"
                    sx={{ fontWeight: 600 }}
                  >
                    (самая низкая комиссия в
                    «Белагропромбанк»)
                  </Box>
                </>
              }
            />
          </ListItem>

          <ListItem
            sx={{
              display: "list-item",
              listStyleType: "disc",
              py: 0.25,
            }}
          >
            <ListItemText
              primary="в отделениях Белпочты (комиссия 1.98 руб. за один платёж)"
            />
          </ListItem>
        </List>

        {/* Информация о комиссии */}
        <Alert
          severity="info"
          sx={{ mb: 3 }}
        >
          Если оплачиваете с комиссией, можно
          оплатить сразу за несколько месяцев
          вперёд (комиссия одна).
          Сумма переплаты будет зачислена нами
          в аванс (предоплата), а средства
          зачтутся в последующем.
        </Alert>

        {/* Выбор услуги */}
        {!summ && (
          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={1}
            sx={{ mb: 3 }}
          >
            <Button
              variant={
                service === "subscription"
                  ? "contained"
                  : "outlined"
              }
              onClick={() =>
                changeService("subscription")
              }
            >
              Абонентская плата
            </Button>

            <Button
              variant={
                service === "adv"
                  ? "contained"
                  : "outlined"
              }
              onClick={() =>
                changeService("adv")
              }
            >
              Реклама
            </Button>
          </Stack>
        )}

        {/* Путь ЕРИП, QR-код, код услуги, сумма */}
        <EripPayment
          service={service}
          summ={summ}
        />

        {/* Предупреждение */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 3 }}
        >
          Перед подтверждением платежа внимательно
          проверяйте введённые данные.
        </Typography>
      </Paper>
    </Container>
  );
}
